<template>
  <div>
    <v-row no-gutters wrap>
      <v-col>
        <v-carousel v-if="!user" interval="15000" cycle hide-delimiter-background delimiter-icon="fiber_manual_record" show-arrows-on-hover height="fit-content">
          <v-carousel-item>
            <v-sheet :style="{backgroundImage: 'linear-gradient(#1F6318, #EAEDED)'}" align="center" height="100%" class="pt-5 pb-16">
              <v-row>
                <v-col xs="10" offset-xs="1" md="8" offset-md="2">
                  <p class='text-h5'>Number one farmers' platform in Zambia</p>
                  <p class="px-2">Zambezi farmer is a platform dedicated to Independent and Business suppliers, we help you get your products on the internet in the presence of all potential customers. Just bring your products and let the platform do the hard work for you.</p>
                  <v-row wrap justify="center" align="center">
                    <v-btn class="ma-2 primary" to="/sign-up/supplier">Join as supplier</v-btn>
                    <v-btn class="ma-2 white primary--text" to="/sign-in">Already supplier?</v-btn>
                  </v-row>
                  <template v-if="isRunningOnWeb">
                    <p class='mt-5 mb-0 black--text font-weight-bold'>Get our App on Google Play Store</p>
                    <v-row wrap justify="center" align="center">
                      <a href='https://play.google.com/store/apps/details?id=com.farmer.zambezi' target="_blank">
                        <img alt='Get it on Google Play' src='@/assets/google-play-badge.png' width="auto" height="80"/>
                      </a>
                    </v-row>
                  </template>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet :style="{backgroundImage: 'linear-gradient(#1C8484, #EAEDED)'}" align="center" height="100%" class="pt-5 pb-16" tile>
              <v-row class="mb-6">
                <v-col xs="10" offset-xs="1" md="8" offset-md="2">
                  <p class='text-h5'>Number one farmers' platform in Zambia</p>
                  <p class="px-2">Whether you are an Independent or a Business customer, we make sure you get the best price on our platform.</p>
                  <v-row wrap justify="center" align="center">
                    <v-btn class="ma-2 farmer_teal" to="/sign-up/customer">Join as customer</v-btn>
                    <v-btn class="ma-2 white farmer_teal--text" to="/sign-in">Already customer?</v-btn>
                  </v-row>
                  <template v-if="isRunningOnWeb">
                    <p class='mt-5 mb-0 black--text font-weight-bold'>Get our App on Google Play Store</p>
                    <v-row wrap justify="center" align="center">
                      <a href='https://play.google.com/store/apps/details?id=com.farmer.zambezi' target="_blank">
                        <img alt='Get it on Google Play' src='@/assets/google-play-badge.png' width="auto" height="80"/>
                      </a>
                    </v-row>
                  </template>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <v-container fluid>
      <v-row v-if="!currentProducts.length" row wrap mx-4 pb-5>
        <v-col v-for="(item, index) in 10" :key="index" class="pa-3" cols="12" sm="6" md="4" lg="3" xl="2">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
      </v-row>
      <!-- <v-row v-else> -->
      <v-data-iterator v-else :items="currentProducts" :items-per-page.sync="itemsPerPage" :page="page" :search="search" :sort-by="sortBy.toLowerCase()" :sort-desc="sortDesc" hide-default-footer >
          <template v-slot:header>
            <v-toolbar class="" flat rounded>
              <v-text-field v-model="search" clearable solo hide-details prepend-inner-icon="search" label="Search"></v-text-field>
              <template v-if="$vuetify.breakpoint.mdAndUp">
                <v-spacer></v-spacer>
                <v-select v-model="sortBy" solo hide-details :items="keys" label="Sort by"></v-select>
                <v-btn-toggle raised v-model="sortDesc" mandatory>
                    <v-card-actions>
                      <v-btn large :value="false">
                        <v-icon>keyboard_arrow_up</v-icon>
                      </v-btn>
                      <v-btn large :value="true">
                        <v-icon>keyboard_arrow_down</v-icon>
                      </v-btn>
                    </v-card-actions>
                </v-btn-toggle>
              </template>
            </v-toolbar>
          </template>

          <template v-slot:default="props">
            <v-row>
              <v-col v-for="(item, index) in props.items" :key="index" cols="12" sm="6" md="4" lg="3" xl="2">
                <v-hover v-slot:default="{ hover }">
                  <v-card @click="goToProduct(item)">
                    <div class="pa-2">
                      <v-img height="200px" width="auto" :src="item.resizedUrl" contain>
                        <v-expand-transition>
                          <div v-if="hover" class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text" style="height: 100%;" >
                            {{item.price}} ZK
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </div>
                    <v-card-text  style="position: relative;">
                        <p class="font-weight-black">{{item.title | limitChars(35)}}<span v-if="item.title.length > 35">...</span></p>
                        <p class="font-weight-bold mt-1 mb-0">
                          <span class="font-weight-bold">Price: </span>
                          <span class="font-weight-bold button">{{item.price}} ZK</span>
                          <span class="font-weight-light caption">/{{item.unit}}</span>
                        </p>
                        <p class="mt-1 mb-0">
                          <span class="font-weight-bold">Category: </span>
                          {{item.category}}
                        </p>
                        <p class="mt-1 mb-0">
                          <span class="font-weight-bold">Location: </span>
                          {{item.district }},  {{item.province }}
                        </p>
                        <FavoriteBtn :product="item"/>
                      </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <v-pagination v-model="pageNumber" :length="nbPages" :total-visible="6" circle></v-pagination>
            </v-row>
          </template>
        </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'
// import { Capacitor } from '@capacitor/core'

export default {
  name: 'Home',
  components: {
    FavoriteBtn: () => import('@/components/product/FavoriteBtn')
  },
  data() {
    return {
      dialog: false,
      itemsPerPageArray: [4, 8, 12],
      search: '',
      filter: {},
      sortDesc: false,
      page: 1,
      // itemsPerPage: 4,
      sortBy: '',
      keys: [
        'price',
        'category',
        'district',
        'province'
      ],
      pageNumber: 1,
      products: []
    }
  },
  computed: {
    ...mapGetters(['user', 'allProducts', 'itemsPerPage', 'productsCounter', 'currentProducts', 'favoriteProductsIds', 'isRunningOnWeb']),
    nbPages() {
      return Math.ceil(this.productsCounter / this.itemsPerPage)
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'Name')
    },
    isFavorite() {
      return id => this.favoriteProductsIds.includes(id)
    }
  },
  watch: {
    pageNumber(newVal, oldVal) {
      this.paginate(newVal)
    }
  },
  filters: {
    limitChars(string, limit) {
      if (!string) return ''
      string = string.toString()
      return string.substring(0, limit)
    }
  },
  methods: {
    paginate(pageNumber) {
      /**
       * no need to make a firebase request if elements are already in the store
       */
      window.scrollTo(0, 0)
      if ((pageNumber - 1) * this.itemsPerPage < this.allProducts.length) {
        store.dispatch('getCurrentStoreProducts', pageNumber)
      } else {
        store.dispatch('getNextProducts')
      }
    },
    goToProduct(item) {
      if (!store.getters.supplierById(item.supplierId)) {
        const supplier = {
          id: item.supplierId,
          type: item.supplierType
        }
        store.dispatch('fetchSupplierInfo', supplier)
      }
      this.$router.push({
        name: 'Product',
        params: { id: item.id }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
</style>
